import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import DefaultCPButton from './defaultCommandPanelButton';

function ExportXLSButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faFileExcel} />}
    />
  );
}

ExportXLSButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ExportXLSButton.defaultProps = {
  content: 'Експортувати в XLSx',
  disabled: false,
};

export default ExportXLSButton;
